module.exports = __webpack_public_path__ + "static/media/secretar_logo_on_black.6a5352c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/secretar_logo_on_black.png
// module id = 2843
// module chunks = 0